import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 100;
const BOTTOM_NAV_HEIGHT = 56;
const SUB_NAV_HEIGHT = 58;

const LayoutContent = ({ element: ReactComponent }) => {
  const { pathname } = useLocation();
  const isSectionRoute =
    pathname.startsWith("/fitness") || pathname.startsWith("/nutrition");

  return (
    <Box
      sx={{
        flexGrow: 1,
        overflow: "auto",
        minHeight: "100%",
        paddingTop: {
          xs: `${isSectionRoute ? APP_BAR_MOBILE + SUB_NAV_HEIGHT : APP_BAR_MOBILE}px`,
          lg: `${APP_BAR_DESKTOP}px`,
        },
        paddingBottom: {
          xs: `${BOTTOM_NAV_HEIGHT + 16}px`,
          lg: "8px",
        },
      }}
    >
      <ReactComponent />
    </Box>
  );
};

export default LayoutContent;
